import { Icon } from '@aibees/shared/components';
import { classnames, fCredit } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { CurrentPlanCreditProps as Props } from './types';

export const CurrentPlanCredit = memo(
  ({ className, currentPlan, subscriptionType }: Props) => {
    const currentPlanCredit = currentPlan?.plan?.metadata.request || 0;

    return (
      <Styled.Wrapper
        className={classnames('CurrentPlanCredit', className)}
        sx={SX.root}
        justifyContent="center"
        alignItems="center"
      >
        {!(subscriptionType === 'Request') && (
          <Icon name="coin" size={16} color="primary.500" />
        )}
        <Typography
          variant="body4"
          fontWeight={400}
          color="black"
          sx={{ textWrap: 'nowrap' }}
        >
          {subscriptionType === 'Request'
            ? 'Request / Credit in Plan'
            : 'Credit in Plan'}{' '}
        </Typography>
        <Typography variant="body3" fontWeight={700} color="primary.600">
          {fCredit(Number(currentPlanCredit))}{' '}
          {subscriptionType === 'Request' && 'Requests'}
        </Typography>
      </Styled.Wrapper>
    );
  }
);

CurrentPlanCredit.displayName = 'CurrentPlanCredit';
